import { HorizontalLayout, LayoutProps } from '@jsonforms/core';
import { LayoutRendererProps } from '@components/uploadForm/renderers/views/layouts/GroupLayout';
import { LayoutRenderer } from '@components/uploadForm/renderers/views/layouts/LayoutRenderer';

type HorizontalLayoutWithLabel = HorizontalLayout & { label?: string };

export const HorizontalLayoutRenderer = ({
  uischema,
  renderers,
  cells,
  schema,
  path,
  enabled,
  visible,
}: LayoutProps) => {
  const layout = uischema as HorizontalLayoutWithLabel;

  const childProps: LayoutRendererProps = {
    elements: layout.elements,
    schema,
    path,
    enabled,
    direction: 'row',
    visible,
  };
  return (
    <div className={'flex justify-between flex-nowrap w-full'}>
      {layout.label &&
        <h3 className={'min-w-[46%] text-nowrap mt-4 ml-2 font-semibold text-1424'}>
          {layout.label}
        </h3>
      }
      <LayoutRenderer {...childProps} renderers={renderers} cells={cells} />
    </div>
  );
};
